// extracted by mini-css-extract-plugin
module.exports = {"root":"GPHeR","container":"_1W_lr","title":"_3Xtrt","icon":"JomVa"};